/**
 * Detecta si la app fue cargada como retorno de un login federado por redirect
 * (p. ej. LinkedIn), en vez de por un popup (Google/Facebook/Apple).
 * Genérico: se basa en el patrón estándar OAuth2 de authorization code (`code`/`error`
 * en la query string), no en un proveedor específico.
 */
export function isReturningFromFederatedRedirect(search: string = window.location.search): boolean {
  const params = new URLSearchParams(search);
  return params.has('code') || params.has('error');
}
